import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProgramsBrowse.css";
const img = require("./assets/images/additive-manufacturing.png");// Import image for program
const programs = [
  { name: "Additive Manufacturing", image: "/images/additive-manufacturing.jpg", path: "/mtech/additive-manufacturing" },
  { name: "Integrated Sensor Systems", image: "/images/integrated-sensors.jpg", path: "/mtech/integrated-sensors" },
  { name: "Polymers & Bio Systems Engineering", image: "/images/polymers-bio.jpg", path: "/mtech/polymers-bio" },
  { name: "Smart Mobility", image: "/images/smart-mobility.jpg", path: "/mtech/smart-mobility" },
  { name: "Medical Device Innovation", image: "/images/medical-devices.jpg", path: "/mtech/medical-devices" },
  { name: "Ophthalmic Engineering", image: "/images/ophthalmic.jpg", path: "/mtech/ophthalmic-engineering" },
  { name: "Integrated Circuits & Microsystems", image: "/images/integrated-circuits.jpg", path: "/mtech/integrated-circuits" },
  { name: "Computational Materials Engineering (Online)", image: "/images/computational-materials.jpg", path: "/mtech/computational-materials" },
  { name: "Electric Vehicle Technology (Online)", image: "/images/electric-vehicles.jpg", path: "/mtech/electric-vehicles" },
];

const ProgramsBrowse = () => {
  const navigate = useNavigate();

  return (
    <div className="browse-container">
      <h1 className="browse-title">Explore Our M.Tech Programs</h1>
      <p className="browse-subtitle">Click on any program to learn more about it.</p>

      <div className="programs-grid">
        {programs.map((program, index) => (
          <div key={index} className="program-card" onClick={() => navigate(program.path)}>
            <div className="program-image-wrapper">
              <img src={img} alt={program.name} className="program-image" />
              <div className="program-name">{program.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgramsBrowse;



// import React from "react";
// import { FaEnvelope, FaFileDownload, FaLink } from "react-icons/fa";
// import "./Programs.css";

// const Prog_MTech = () => {
//   return (
//     <div>
//       <div className="programs-container">
//         <div className="programs-header">
//           <h1>Interdisciplinary M.Tech Programs</h1>
//         </div>
//         <div className="programs-content">
//           <p className="programs-intro">
//             The Institute has formalized <strong>"Nine"</strong> M.Tech
//             interdisciplinary programs as part of CIP. The brochures to
//             individual programs can be downloaded by clicking on the respective
//             links below.
//           </p>
//           <div className="programs-table-wrapper">
//             <table className="programs-table">
//               <thead>
//                 <tr>
//                   <th>M.Tech Program</th>
//                   <th>Faculty Coordinator</th>
//                   <th>Brochure &amp; Time Table</th>
//                   <th>Curriculum</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {/* 1) M.Tech in Additive Manufacturing */}
//                 <tr>
//                   <td>M.Tech in Additive Manufacturing</td>
//                   <td>
//                     {/* Coordinator #1 */}
//                     <div className="coordinator-block">
//                       Dr Prasad Onkar (DES)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:psonkar@des.iith.ac.in">
//                           psonkar@des.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                     {/* Coordinator #2 */}
//                     <div className="coordinator-block">
//                       Dr Falguni Pati (BME)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:falguni@bme.iith.ac.in">
//                           falguni@bme.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#brochure-AM">Click here to download brochure</a>
//                     </div>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#timeTable-AM">
//                         Click here to download time table
//                       </a>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-AM">
//                       Click here to download AM Curriculum
//                     </a>
//                   </td>
//                 </tr>
//                 {/* 2) M.Tech in Integrated Sensor Systems */}
//                 <tr>
//                   <td>M.Tech in Integrated Sensor Systems</td>
//                   <td>
//                     <div className="coordinator-block">
//                       Dr. Naresh Kumar Emani (EE)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:naresh@ee.iith.ac.in">
//                           naresh@ee.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#brochure-ISS">
//                         Click here to download brochure
//                       </a>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-ISS">
//                       Click here to download ISS Curriculum
//                     </a>
//                   </td>
//                 </tr>
//                 {/* 3) M.Tech in Polymers & Bio Systems Engineering */}
//                 <tr>
//                   <td>M.Tech. in Polymers &amp; Bio Systems Engineering</td>
//                   <td>
//                     <div className="coordinator-block">
//                       Dr. Lopamudra Giri (CE)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:giril@che.iith.ac.in">
//                           giril@che.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                     <div className="coordinator-block">
//                       Mudrika Khandelwal (MSME)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:mudrika@msme.iith.ac.in">
//                           mudrika@msme.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#brochure-PBS">Click here to download brochure</a>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-PBS">
//                       Click here to download PBS Curriculum
//                     </a>
//                   </td>
//                 </tr>
//                 {/* 4) M. Tech in Smart Mobility */}
//                 <tr>
//                   <td>M. Tech in Smart Mobility</td>
//                   <td>
//                     <div className="coordinator-block">
//                       Dr. Rajalakshmi P. (EE)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:raji@ee.iith.ac.in">
//                           raji@ee.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#brochure-SM1">
//                         Click here to download brochure
//                       </a>
//                     </div>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#brochure-SM2">
//                         Click here to download brochure
//                       </a>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#curriculum-SM2020">
//                         Click here to download SM Curriculm 2020
//                       </a>
//                     </div>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#curriculum-SM2021">
//                         Click here to download SM Curriculm 2021
//                       </a>
//                     </div>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#curriculum-SM2022">
//                         Click here to download SM Curriculm 2022
//                       </a>
//                     </div>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#curriculum-SM3Y2022">
//                         Click here to download SM 3Y Curriculm 2022
//                       </a>
//                     </div>
//                   </td>
//                 </tr>
//                 {/* 5) M. Tech in Medical Device Innovation */}
//                 <tr>
//                   <td>M. Tech in Medical Device Innovation</td>
//                   <td>
//                     <div className="coordinator-block">
//                       Dr. Renu John (BME)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:renujohn@bme.iith.ac.in">
//                           renujohn@bme.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#brochure-MDI">
//                         Click here to download brochure
//                       </a>
//                     </div>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#timeTable-MDI">
//                         Click here to download time table
//                       </a>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-MDI">
//                       Click here to download MDI curriculum
//                     </a>
//                   </td>
//                 </tr>
//                 {/* 6) M. Tech in Opthalmic Engineering */}
//                 <tr>
//                   <td>M. Tech in Opthalmic Engineering</td>
//                   <td>
//                     <div className="coordinator-block">
//                       Dr. Nithyanandan K (PHY)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:nithyan@phy.iith.ac.in">
//                           nithyan@phy.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaFileDownload className="icon" />
//                       <a href="#brochure-OPE">
//                         Click here to download brochure
//                       </a>
//                     </div>
//                     <div className="download-link">
//                       <FaLink className="icon" />
//                       <a href="#website-OPE">Click here to view the website</a>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-OPE">
//                       Click here to download OPE Curriculum
//                     </a>
//                   </td>
//                 </tr>
//                 {/* 7) M. Tech in Integrated Circiuts and Microsystem Packaging */}
//                 <tr>
//                   <td>
//                     M. Tech in Integrated Circiuts and Microsystem Packaging
//                   </td>
//                   <td>
//                     <div className="coordinator-block">
//                       Prof. Shiva Rama Krishna Vanjari (EE)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:svanjari@ee.iith.ac.in">
//                           svanjari@ee.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaLink className="icon" />
//                       <a href="#website-ICMP">Click here to view the website</a>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-ICMP">
//                       Click here to view course curriculum
//                     </a>
//                   </td>
//                 </tr>
//                 {/*
//                     If you have more programs (up to 9 total),
//                     copy/paste additional <tr> blocks as needed.
//                   */}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//       <div className="programs-container">
//         <div className="programs-header">
//           <h1>Online M.Tech Programs</h1>
//         </div>
//         <div className="programs-content">
//           <p className="programs-intro">
//             The Institute has formalized <strong>"Two"</strong> Online MTech
//             interdisciplinary programs as part of CIP. The brochures to
//             individual programs can be downloaded by clicking on each program.
//           </p>
//           <div className="programs-table-wrapper">
//             <table className="programs-table">
//               <thead>
//                 <tr>
//                   <th>M.Tech Program</th>
//                   <th>Faculty Coordinator</th>
//                   <th>Website</th>
//                   <th>Brochure</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>
//                     M.Tech in Integrated Computational Materials Engineering
//                   </td>
//                   <td>
//                     {/* Coordinator #1 */}
//                     <div className="coordinator-block">
//                       Dr.Saswata Bhattacharya (MSME)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:saswata@msme.iith.ac.in">
//                           saswata@msme.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaLink className="icon" />
//                       <a href="#brochure-AM">Click here to view the website</a>
//                     </div>
//                   </td>
//                   <td>
//                     <FaFileDownload className="icon" />
//                     <a href="#curriculum-AM">
//                       Click here to download the brochure.
//                     </a>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>
//                   M. Tech. in Electrical Vehicle Technology
//                   </td>
//                   <td>
//                     {/* Coordinator #1 */}
//                     <div className="coordinator-block">
//                     Dr. Prabhat Kumar (MAE)
//                       <div className="email-line">
//                         <FaEnvelope className="icon" />
//                         <a href="mailto:pkumar@mae.iith.ac.in">
//                           pkumar@mae.iith.ac.in
//                         </a>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <div className="download-link">
//                       <FaLink className="icon" />
//                       <a href="#brochure-AM">Click here to view the website</a>
//                     </div>
//                   </td>
//                   <td>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Prog_MTech;
